module.exports = __webpack_public_path__ + "img/image1.0bbd27a.svg";